<template>
    <div v-if="paper" class=publication>
        <b>"{{ paper.title }}"</b>
        <span v-if="paper.award" style="color:#C00000"><br><b>{{ paper.award }}</b></span>
        <br>
        <span v-for="line in paper.rest" :key="line">{{ line }}<br> </span>
        [<a class=url :href="paper.url" target="new">PDF</a>]
        [<router-link class=url :to="{ path: '/reference', query: { bid: paperId } }">bib</router-link>]
        [<router-link class=url :to="'/copyright'">&copy;</router-link>]
        <span v-if="paper.projectPage && includeProjectPage">
            [<a v-if="paper.projectPage[0].special" class=url
                :href="paper.projectPage[0].url">Project Page</a>
            <router-link class=url v-else :to="{
                path: '/projects/categories/project',
                query: { cid: paper.projectPage[0].cate, pid: paper.projectPage[0].proj }
            }">Project Page</router-link>]
        </span>
        <br>
    </div>
</template>

<script>
import papers from "@/assets/publications/APA.json"

export default {
    props: {
        paperId: {
            type: Number,
            required: true
        },
        includeProjectPage: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        paper() {
            return papers[this.paperId] || null;
        }
    }
};

</script>

<style lang="css" scoped>
.publication {
    margin-top: 1.6rem;
    text-align: left;
}

.url {
    text-decoration: none;
    color: #000;
}
</style>
